export const toSlug = (str: string) => {
  if (!str || typeof str !== "string") return "_";
  return str
    .replace(/[^a-zA-Z ]/g, "")
    .replace(/\s/g, "-")
    .toLowerCase();
};
